<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">



    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <p class="font-medium"><span class="hidden md:inline-block">{{ $store.state.auth.firebaseUser.email }}</span><feather-icon svgClasses="w-7 h-7 icon-up-sm" class="ml-1 cursor-pointer float-right" icon="UserIcon" @click.stop="showSidebar" /></p>
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown text-dark text-lg">
        <ul style="min-width: 10rem">

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="() => {
              if ($route.name !== 'settings-myprofile') {
                $router.push('/dash/settings/myprofile')
              }
              }">
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">My Profile</span>
          </li>
          <vs-divider class="m-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="() => {
              if ($route.name !== 'settings-notifications') {
                $router.push('/dash/settings/notifications')
              }
              }">
            <feather-icon icon="BellIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Notifications</span>
          </li>
          <vs-divider class="m-1" />
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="signOut">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>

/*

<vs-divider class="m-1" />

<li
  class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
  @click="() => {
      $router.push('/dash/addnew')
      $store.commit('signUpState/RESET_SIGNUP_STATE')
      $store.commit('LOAD_ADDNEW_STATE')
    }">
  <feather-icon icon="PlusSquareIcon" svgClasses="w-4 h-4" />
  <span class="ml-2">Add New Location</span>
</li>

*/


import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data () {
    return {

    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  created() {
    //window.gtfo = this.signOut
  },
  methods: {
    signOut () {

      this.$store.dispatch('auth/logout').then(() => {
        //the main.js code will catch auth state change
      }).catch(() => {})

    }
  }
}
</script>
